module.exports = __webpack_public_path__ + "4bd652ba50c8f6cf0f57a158d585e24c.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-BoldItalic.ttf
// module id = 990
// module chunks = 0